(function()
{
	var Application = include('springroll.Application');
	var BreathMeter = include('nature.BreathMeter');
	var Button = include('springroll.pixi.Button');
	var ButtonSounds = include('springroll.ButtonSounds');
	var Camera = include('nature.Camera');
	var Character = include('nature.Character');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var HighScoreMarker = include('nature.HighScoreMarker');
	var HUD = include('nature.HUD');
	var Tween = include('createjs.Tween');
	var PauseMenu = include('nature.PauseMenu');
	var ScoreCharacters = include('nature.ScoreCharacters');
	var ScoreDisplay = include('nature.ScoreDisplay');
	var SeedContainer = include('nature.SeedContainer');

	var _app = null;

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class nature.GamePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var GamePanel = function()
	{
		Container.call(this);
	};

	//extend the base panel
	var s = Container.prototype;
	var p = extend(GamePanel, Container);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function(config)
	{
		this.config = config;

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		_app = Application.instance;

		/**
		 * Control the world viewport
		 * @property {nature.Camera} camera
		 */
		this.camera = new Camera();

		/**
		 * Node for handling the reponsive scaling
		 * @property {PIXI.Container} worldScaler
		 */
		this.worldScaler = new Container();
		this.addChild(this.worldScaler);

		/**
		 * Contains all of the world elements for panning
		 * @property {PIXI.Container} worldContainer
		 */
		this.worldContainer = new Container();
		this.worldScaler.addChild(this.worldContainer);
		this.camera.world = this.worldContainer;

		/**
		 * The MovieClip animation
		 * @property {pixiflash.MovieClip} natureCat
		 */
		this.natureCat = mixin(new pixiflash_lib.NatureCatArt(), Character);
		this.worldContainer.addChild(this.natureCat);

		this.highScoreMarker = mixin(new pixiflash_lib.HighScoreFlower(), HighScoreMarker);
		if (_app.userHighScore > 50 && !_app.isTutorial)
		{
			this.worldContainer.addChild(this.highScoreMarker);
		}

		/**
		 * The interactive element to get touch/click events to control the
		 * gameplay. does not scroll so not part of the breathMeter
		 * @property {PIXI.Container} touchGetter
		 */
		this.touchGetter = new Container();
		this.touchGetter.interactive = true;
		this.addChild(this.touchGetter);

		/**
		 * Nature Cat breathing meter
		 * @property {nature.BreathMeter} breathMeter
		 */
		this.breathMeter = mixin(new pixiflash_lib.BreathMeter(),
			BreathMeter,
			config.ui.breathMeter,
			this.touchGetter
		);
		this.worldContainer.addChild(this.breathMeter);

		/**
		 * @property {nature.ScoreCharacters}
		 */
		this.uiContainer = new Container();
		this.addChild(this.uiContainer);

		/**
		 * The heads-up display for the game
		 * @property {nature.HUD} hud
		 */
		this.hud = new HUD(config.ui.hud);
		this.addChild(this.hud);

		/**
		 * The resulting score display
		 * @property {nature.ScoreDisplay} score
		 */
		this.scoreDisplay = new ScoreDisplay(config.ui.score);
		this.addChild(this.scoreDisplay);

		/**
		 * @property {nature.ScoreCharacters}
		 */
		this.scoreCharacters = new ScoreCharacters();
		this.addChild(this.scoreCharacters);

		/**
		 * The button to skip the tutorial
		 * @property {springroll.pixi.Button} skipButton
		 */
		this.skipButton = new Button(config.ui.skipButton);
		this.buttonSounds = new ButtonSounds('ButtonSelect', 'ButtonRollover', this.skipButton);
		this.addChild(this.skipButton);
		this.skipButton.visible = false;

		/**
		 * The pause menu
		 * @property {nature.PauseMenu} pauseMenu
		 */
		this.pauseMenu = new PauseMenu(
			config.ui.pauseMenu,
			config.scalingSize
		);

		/**
		 * The collection of seeds
		 * @property {nature.SeedContainer} seeds
		 */
		this.seedContainer = null;

		/**
		 * The collection of world elements
		 * @property {Array} floaters
		 */
		this.floaters = [];
	};

	/**
	 * Setup the blowing
	 * @method setupBlow
	 */
	p.setupBlow = function()
	{
		this.natureCat.visible = true;
		var timeline = _app.animator.play(this.natureCat,
		{
			anim: 'breathe'
		});

		_app.sound.play('NCat_BreatheLoop',
		{
			loop: true
		});

		// Tutorial when it pauses at the top
		// then we'll stop the animation
		var breathMeter = this.breathMeter;
		breathMeter.start(timeline);
		var app = this.app;
		this.onPause = this.onPause.bind(this);
		breathMeter.once('paused', this.onPause);
		this.hud.show(false);
	};

	p.onPause = function()
	{
		_app.sound.stop('NCat_BreatheLoop');
		_app.animator.getTimeline(this.natureCat).paused = true;
	};

	/**
	 * Setup the gameplay
	 * @method setupGameplay
	 */
	p.setupGameplay = function()
	{
		// Create seeds here to help with restarting
		if (this.seedContainer)
		{
			this.worldContainer.removeChild(this.seedContainer);
			this.seedContainer.destroy();
		}

		// Create the new seeds container
		this.seedContainer = new SeedContainer(this);
		this.worldContainer.addChild(this.seedContainer);

		this.camera.target = this.seedContainer;
		this.floaters.length = 0;
	};

	/**
	 * Get the absolute distance
	 * @property {Number} pixelDistance
	 * @readOnly
	 */
	Object.defineProperty(p, 'pixelDistance',
	{
		get: function()
		{
			return -this.worldContainer.x;
		}
	});

	p.teardown = function()
	{
		for (var i = 0, len = this.floaters.length; i < len; i++)
		{
			var floater = this.floaters[i];
			if (floater.parent)
			{
				floater.parent.removeChild(floater);
			}
			if (floater.sfx)
			{
				_app.sound.stop(floater.sfx);
			}
		}
		this.floaters.length = 0;

		// Remove everything
		this.worldScaler.removeChildren();
		this.worldContainer.removeChildren();
		this.uiContainer.removeChildren();
		this.removeChildren();

		// Possible destroyable assets
		var destroyables = [
			this.breathMeter,
			this.camera,
			this.buttonSounds,
			this.highScoreMarker,
			this.hud,
			this.natureCat,
			this.pauseMenu,
			this.scoreDisplay,
			this.scoreCharacters,
			this.seedContainer,
			this.skipButton,
			this.touchGetter
		];
		for (i = 0, len = destroyables.length; i < len; i++)
		{
			var d = destroyables[i];
			Tween.removeTweens(d);
			if (d && d.destroy)
				d.destroy(true);
		}
		
		destroyables = null;

		this.breathMeter = null;
		this.buttonSounds = null;
		this.camera = null;
		this.floaters = null;
		this.highScoreMarker = null;
		this.hud = null;
		this.natureCat = null;
		this.pauseMenu = null;
		this.scoreCharacters = null;
		this.scoreDisplay = null;
		this.seedContainer = null;
		this.skipButton = null;
		this.touchGetter = null;
		this.worldContainer = null;
		this.worldScaler = null;

		_app = null;
	};

	// Assign to namespace
	namespace('nature').GamePanel = GamePanel;
}());